import "@fontsource/ibm-plex-mono"
import "@aet/react-inspector/dist/index.css"
import "./index.css"
import { HeroUIProvider } from "@heroui/react"
import { ToastProvider } from "@heroui/toast"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

export function renderMain(children: React.ReactNode) {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <HeroUIProvider>
        <ToastProvider placement="top-right" />
        <NextThemesProvider attribute="class">{children}</NextThemesProvider>
      </HeroUIProvider>
    </StrictMode>
  )
}
